import { TypedSupabaseClient } from "../../utils/types";

export function getVenue(client: TypedSupabaseClient, venueId: string) {
  return client
    .from("venues")
    .select(
      `estimated_waiting_time,id,name,oid,payment,phone_number,pricing,pricing_policy,scheduler_ext_id,timezone,tips`
    )
    .eq("id", venueId)
    .single();
}
